// Used to manage application level state
// Passing state in between non-nested pages
// An alternative to GET arguments

class StateStore {
  constructor() {
    // Report Pages
    this.reports = {};
    this.reports.selectedBranches = null;
  }
}

let stateStore = new StateStore();

export default stateStore;
